<template>
	<div id="coce-footer" class="h-20 w-full bg-fau-blue relative flex justify-between items-center md:justify-between md:px-16 px-8">
	      <img class="h-[40px]" src="../assets/logo-owl.svg" alt="" />
	      <img class="h-[30px] ml-4" src="../assets/logo-coce.svg" alt="" />
	    </div>
</template>
